const post = {
  slug: 'welcome',
  title: '"if it aint broke dont fix it"',
  date: '2026-05-08',
  excerpt: 'A story about how I broke my Vespa for about 3 weeks.',
  content: (
    <>
      <p>I tried to fix something that wasn't broken and I ended up breaking it instead.</p>
      <p>If you don't ride motorbikes or scooters, you may not know that they typically have silent indicators. This means when you flick the indicators on, there's no clicking sound, so often you forget they are on and don't cancel them. From a communication point of view, this is not ideal, so I wanted to modify my scooter to click when the indicator is on.</p>
      <p>The easiest method to achieve this is to swap out the original silent relay with one that makes sound. My original one was solid-state, so all I had to do was get a mechanical one which makes a ticking sound and swap it in. This would be a 30 minute job - or so I thought...</p>

      <p>
        On opening it 
      </p>


    </>
  ),
};

export default post;
